import React, { FC } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { PermissionCheckComponent } from '../../../common/component/layout/PermissionCheckComponent';
import { CspPath } from '../../../CspPath';
import { PermissionType } from '../../security/type/PermissionType';
import { SiteDetailsContextProvider } from '../../site/site-details/context/SiteDetailsContextProvider';
import { PathUtil } from '../util/PathUtil';

const SiteDetailsRoot: FC = () => (
  <PermissionCheckComponent permission={PermissionType.CAN_VIEW_SITES}>
    <SiteDetailsContextProvider>
      <Outlet />
    </SiteDetailsContextProvider>
  </PermissionCheckComponent>
);

const SiteDetailsPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../site/site-details/page/SiteDetailsPage'),
);

const EditContactDetailsDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-details/edit-contact-details/container/EditContactDetailsDrawerContainer'
    ),
);

const AddAdditionalLocationDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-details/add-additional-location/container/AddAdditionalLocationDrawerContainer'
    ),
);

const EditAdditionalLocationDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-details/edit-additional-location/container/EditAdditionalLocationDrawerContainer'
    ),
);

const ReplaceAdditionalLocationDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-details/replace-additional-location/container/ReplaceAdditionalLocationDrawerContainer'
    ),
);

const EditEcApprovalStatusDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-details/ec-approval/container/EditEcApprovalStatusDrawerContainer'
    ),
);

export const SiteDetailsRoutes: RouteObject[] = [
  {
    element: <SiteDetailsRoot />,
    children: [
      {
        path: '',
        element: <SiteDetailsPage />,
        children: [
          {
            path: PathUtil.toRelativePath(CspPath.SITE_DETAILS, CspPath.SITE_DETAILS_EDIT_CONTACT_DETAILS, true),
            element: <EditContactDetailsDrawerContainer />,
          },
          {
            path: PathUtil.toRelativePath(CspPath.SITE_DETAILS, CspPath.SITE_DETAILS_CHANGE_EC_APPROVAL_STATUS, true),
            element: <EditEcApprovalStatusDrawerContainer />,
          },
          {
            path: PathUtil.toRelativePath(CspPath.SITE_DETAILS, CspPath.SITE_DETAILS_ADD_ADDITIONAL_LOCATION, true),
            element: <AddAdditionalLocationDrawerContainer />,
          },
          {
            path: PathUtil.toRelativePath(CspPath.SITE_DETAILS, CspPath.SITE_DETAILS_EDIT_ADDITIONAL_LOCATION, true),
            element: <EditAdditionalLocationDrawerContainer />,
          },
          {
            path: PathUtil.toRelativePath(CspPath.SITE_DETAILS, CspPath.SITE_DETAILS_REPLACE_ADDITIONAL_LOCATION, true),
            element: <ReplaceAdditionalLocationDrawerContainer />,
          },
        ],
      },
    ],
  },
];
